import AssignmentIcon from '@mui/icons-material/Assignment';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DescriptionIcon from '@mui/icons-material/Description';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LanguageIcon from '@mui/icons-material/Language';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MapIcon from '@mui/icons-material/Map';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PeopleIcon from '@mui/icons-material/People';
import PostAddIcon from '@mui/icons-material/PostAdd';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import TuneIcon from '@mui/icons-material/Tune';
import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import NavBar from './NavBar';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import SendingProgressSnackbar from 'FRONTEND/components/SendingProgressSnackbar';
import SupportDrawer from 'FRONTEND/components/SupportDrawer';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.scss';

const ICONS = {
  AssignmentIcon,
  DateRangeIcon,
  DescriptionIcon,
  EventAvailableIcon,
  LanguageIcon,
  LocalHospitalIcon,
  PeopleIcon,
  RecentActorsIcon,
  MapIcon,
  EmergencyRecordingIcon,
  TuneIcon,
  OpenInNewIcon,
  PostAddIcon,
};

export default (element, store) => {
  element.innerHTML = '';
  const tabs = element.dataset.tabs && JSON.parse(element.dataset.tabs);
  if (tabs) {
    tabs.forEach((tab) => {
      const IconComponent = ICONS[tab.icon];
      tab.icon = <IconComponent />;
    });
  }

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <NavBar
            tabs={tabs}
            videoconference={element.dataset.videoconference}
            branding={{
              cloudName: element.dataset.cloudName,
              href: element.dataset.menuHref,
            }}
            hasSupportHref={element.dataset.supportHref}
          />
          <SendingProgressSnackbar />
          <SupportDrawer />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );
};
